import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Table,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import {
  DOG_LICENSE_DETAILS,
  AGENCY_FEE,
  PAYMENT_PROCESS,
  GET_USER,
  UPDATE_LICENSE_STATUS,
} from "../../../constants/ApiPaths";
import {
  authCustomerHeader,
} from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  CardSwipe,
  JSONParser,
  luhnChecksum,
  parseCreditCards,
} from "../../../functions/Helper";
import SuccessPayment from "../../Agency/Payment/SuccessPayment";
import {
  CUSTOMER_PAYMENT_DOG_LICENSE_ID,
} from "../../../constants/LocalStorageVariables";

import HeaderLogo from "../../common/HeaderLogo";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";

const paymentInitial = {
  firstName: "",
  lastName: "",
  address1: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  email: "",
  cardNumber: "",
  expirationMonth: "",
  expirationYear: "",
  cvv2: "",
  userId: 0,
  dogLicenseId: 0,
  paymentType: "",
  responseText: "",
};

export default function AgencyPayment() {
  const history = useNavigate();
  const { dogLicenseId, userId, ttId } = useParams();
  console.log(dogLicenseId, "params lo");
  const [loading, setloading] = useState(false);
  const [texloading, settexloading] = useState(false);
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [paymentValues, setpaymentValues] = useState({});
  const [agencyFee, setagencyFee] = useState({});
  const { licensePlanDetails } = paymentValues;
  const licensePlanData = JSONParser(licensePlanDetails, []);
  const { planAmount } = licensePlanData[0] || {};
  const [cardholderName, setcardholderName] = useState({
    firstName: "",
    lastName: "",
  });
  const Total = planAmount + parseInt(agencyFee);
  let Year = () => {
    var d = new Date();
    var n = d.getFullYear();
    const year = [];
    for (let index = n; index < n + 50; index++) {
      year.push({ value: index.toString().substr(-2), year: index });
    }
    return year;
  };

  const year = Year();
  // const [paymentUser, setpaymentUSer] = useState(paymentInitial);

  let GetUser = async () => {
    setloading(true);
    const config = {
      method: "GET",
      url: GET_USER,
      // headers: authCustomerHeader(),
      params: {
        userId: userId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        console.log(data, "data");
        // setpaymentUSer({ ...paymentUser, ...data, address1: data.address });
        setValues(data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error)
      }
    } finally {
      setloading(false);
    }
  };

  

  const { enqueueSnackbar } = useSnackbar();

  let PaymentDetails = async (e) => {
    setloading(true);
    const config = {
      method: "GET",
      url: DOG_LICENSE_DETAILS,
      // headers: authCustomerHeader(),
      params: {
        dogLicenseId: dogLicenseId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setpaymentValues(data);
        const { licensePlanDetails } = data;
        const licensePlanData = JSONParser(licensePlanDetails, []);
        const { planAmount } = licensePlanData[0] || {};
        AgencyFee(planAmount);
      }
    } catch (error) {
    } finally {
      setloading(false);
    }
  };

  let AgencyFee = async (planAmount) => {
    settexloading(true);
    const config = {
      method: "GET",
      url: AGENCY_FEE,
      // headers: authCustomerHeader(),
      params: {
        ttId: ttId,
        amount: planAmount,
      },
    };
    try {
      const response = await API(config);
      const { status, ServiceFeeAmount } = response.data;
      if (status === "Success") {
        setagencyFee(ServiceFeeAmount);
      }
    } catch (error) {
    } finally {
      settexloading(false);
    }
  };

  const paymentProcess = async () => {
    setloading(true);
    const config = {
      method: "POST",
      url: PAYMENT_PROCESS,
      headers: authCustomerHeader(),
      data: {
        firstName: values.firstName,
        lastName: values.lastName,
        address1: values.address1,
        city: values.city,
        state: values.stateName,
        zip: values.zip,
        phone: values.phoneNumber,
        email: values.email,
        cardNumber: values.cardNumber,
        expirationMonth: values.expirationMonth,
        expirationYear: values.expirationYear,
        cvv2: values.cvv2,
        userId: parseInt(userId),
        dogLicenseId: parseInt(dogLicenseId),
        paymentType: "Debit card",
      },
    };
    try {
      const response = await API(config);

      const { status } = response.data;
      if (status === "Success") {
        let licplanId = window.sessionStorage.getItem(
          "PAYMENT_DOGLICENSE_LICENSEPLANID"
        );
        const conf = {
          method: "PUT",
          url: UPDATE_LICENSE_STATUS,
          data: {
            dogLicenseId: dogLicenseId,
            licenseStatus: "Payment Completed",
            licensePlanId: licplanId,
          },
        };
        try {
          const response1 = await API(conf);
          console.log("sucess",response1);
        } catch (error) {
          console.error(error);
        }
        setIsPaymentSuccess(true);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
    }
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().trim().required("First name is required"),
    lastName: Yup.string().trim().required("Last name is required"),
    expirationMonth: Yup.string()
      .trim()
      .required(" Expiration Month is required"),
    expirationYear: Yup.string().trim().required("Expiration Year is required"),
    cardNumber: Yup.string()
      .trim()
      .min(16, "Card Number is invalid")
      .max(16, "Card Number is invalid")
      .required("Card Number is required"),
    cvv2: Yup.string()
      .min(3, "Cvv Number is invalid")
      .max(4, "Cvv Number is invalid")
      .trim()
      .required("Cvv is required"),
  });
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    setValues,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: { ...paymentInitial, ...cardholderName },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => paymentProcess(values),
  });

  useEffect(() => {
    if (userId) {
      PaymentDetails();
      GetUser();
    }
  }, []);

  const paymentSuccessBtn = () => {
    let dogLicenseId = window.sessionStorage.getItem(
      CUSTOMER_PAYMENT_DOG_LICENSE_ID
    );
    let licplanId = window.sessionStorage.getItem(
      "PAYMENT_DOGLICENSE_LICENSEPLANID"
    );
    window.sessionStorage.clear();
    history(`/customer/view-license/${licplanId}/${dogLicenseId}`);
  };

  if (loading) {
    return <CustomPageLoading />;
  }
  const CardHolderHandle = (e) => {
    const { name, value } = e.target;
    setcardholderName({ ...cardholderName, [name]: value });
  };
  if (isPaymentSuccess) {
    return (
      <SuccessPayment
        handleButton={paymentSuccessBtn}
        buttonLabel="View license"
      />
    );
  }

  const CardHandle = (e) => {
    let { value } = e.target;
    //411111   111    11  1    1111^Smith/John W^2506    201000   00   004200  00000
    // 41111111   11111111 = 250620   100000420  00000;
    // value = value.replace(/\s/g, "");
    const { cardNumber, ...otherValues } = CardSwipe(value);
    if (luhnChecksum(cardNumber)) {
      setValues({
        ...values,
        cardNumber,
        ...otherValues,
      });
      return;
    }
    const parsedValues = parseCreditCards(value);
    if (parsedValues) {
      setValues({
        ...values,
        ...parsedValues,
      });
      return;
    }
    setValues({
      ...values,
      cardNumber: value,
    });
  };
  return (
    <div>
      <HeaderLogo />
      {texloading && <CustomPageLoading />}
      <Container>
        <h4 className="pay-title">Complete Payment </h4>

        <div className="page-title pay-text"></div>

        {/* <div className="new-license"> */}
        <Row>
          <Col sm="12" md={{ size: 5 }} className="mr-auto ml-auto">
            <div className="payment-info">
              <Table responsive>
                <tbody>
                  <tr>
                    <td>{paymentValues.typeofLicense}</td>
                    <td>${parseFloat(planAmount).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Convenience Fee</td>
                    <td>${parseFloat(agencyFee).toFixed(2)}</td>
                  </tr>
                  <tr className="divide">
                    <td>
                      <b>Sub Total</b>
                    </td>
                    <td>
                      <b>${parseFloat(Total).toFixed(2)}</b>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div className="pmt-info-form">
              <div className="divider"></div>
              <p>Add payment card</p>
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="Card Number">First name</Label>
                  <Input
                    type="text"
                    name="firstName"
                    handleBlur={handleBlur}
                    placeholder="Enter first name"
                    invalid={
                      errors.firstName && touched.firstName ? true : false
                    }
                    value={values.firstName}
                    onChange={CardHolderHandle}
                  />
                  <FormFeedback>
                    {errors.firstName && touched.firstName
                      ? errors.firstName
                      : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="Card Number">Last name</Label>
                  <Input
                    type="text"
                    name="lastName"
                    handleBlur={handleBlur}
                    placeholder="Enter last name"
                    invalid={errors.lastName && touched.lastName ? true : false}
                    value={values.lastName}
                    onChange={CardHolderHandle}
                  />
                  <FormFeedback>
                    {errors.lastName && touched.lastName ? errors.lastName : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="Card Number">Card Number</Label>
                  <Input
                    type="text"
                    name="cardNumber"
                    handleBlur={handleBlur}
                    invalid={
                      errors.cardNumber && touched.cardNumber ? true : false
                    }
                    value={values.cardNumber}
                    onChange={CardHandle}
                  />
                  <FormFeedback>
                    {errors.cardNumber && touched.cardNumber
                      ? errors.cardNumber
                      : ""}
                  </FormFeedback>
                </FormGroup>
                <Row form>
                  <Col lg="6" xl="4">
                    <FormGroup>
                      <Label for="Expiration">Expiration month</Label>
                      <Input
                        type="select"
                        name="expirationMonth"
                        handleBlur={handleBlur}
                        invalid={
                          errors.expirationMonth && touched.expirationMonth
                            ? true
                            : false
                        }
                        value={values.expirationMonth}
                        onChange={handleChange}
                      >
                        <option value="">Select Month</option>
                        {[
                          "01",
                          "02",
                          "03",
                          "04",
                          "05",
                          "06",
                          "07",
                          "08",
                          "09",
                          "10",
                          "11",
                          "12",
                        ].map((i, index) => (
                          <option value={i}>{i}</option>
                        ))}
                      </Input>
                      <FormFeedback>
                        {errors.expirationMonth && touched.expirationMonth
                          ? errors.expirationMonth
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg="6" xl="4">
                    <FormGroup>
                      <Label for="Expiration">Year</Label>
                      <Input
                        type="select"
                        handleBlur={handleBlur}
                        invalid={
                          errors.expirationYear && touched.expirationYear
                            ? true
                            : false
                        }
                        value={values.expirationYear}
                        onChange={handleChange}
                        name="expirationYear"
                        id="exampleSelect"
                      >
                        <option value="">Select Year</option>
                        {year.map((i, index) => (
                          <option value={i.value}>{i.year}</option>
                        ))}
                      </Input>
                      <FormFeedback>
                        {errors.expirationYear && touched.expirationYear
                          ? errors.expirationYear
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg="6" xl="4">
                    <FormGroup>
                      <Label for="Card Number">cvv</Label>
                      <Input
                        type="password"
                        handleBlur={handleBlur}
                        invalid={errors.cvv2 && touched.cvv2 ? true : false}
                        value={values.cvv2}
                        onChange={handleChange}
                        name="cvv2"
                        id="exampleSelect"
                      />

                      <FormFeedback>
                        {errors.cvv2 && touched.cvv2 ? errors.cvv2 : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <div className="text-center">
                  <Button
                    disabled={loading}
                    className="ln-btn"
                    type="submit"
                    color="primary"
                    size="lg"
                  >
                    Proceed to Payment
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
        {/* </div> */}
      </Container>
    </div>
  );
}
